<template>
  <div class="header2">
    <div class="header--page">
      <img src="/icons/bgys-active.svg" width="40" class="mr-2 mt-1" />

      {{ $t("product.bgys.product") }}
      <!-- <img src="@/assets/images/arrow-down.png" class="d-none d-xl-block" style="width: 0.625rem; flex-shrink: 0;" /> -->
    </div>
    <div class="d-flex">
      <OrganizationSelector />
      <navbar-notification />
      <!-- <file-manager-progress-widget /> -->
      <file-manager-widget />

      <div class="d-flex align-items-center ml-2">
        <button @click="$router.push('/help-center')" type="button" class="header-item noti-icon custom-header-item" v-b-tooltip.hover :title="this.$t('help.title')">
          <i class="bx bxs-help-circle align-middle font-size-24 text-success"></i>
          <!-- <strong> {{ this.$t("help.title") }}</strong> -->
        </button>
      </div>

      <b-dropdown right variant="black" toggle-class="header-item">
        <template v-slot:button-content>
          <div class="d-flex align-items-center gap-4">
            <img v-if="!user.avatar" src="@/assets/images/user.png" alt="User Logo" style="height: 2.875rem;" />
            <img
              v-else
              :src="user.avatar"
              style="border:1px solid gray; height: 2.875rem;"
              class="
                  avatar-title
                  rounded-circle 
                  bg-white
                "
            />

            <span class="d-none d-xl-block user-name">
              {{ user.name }}
            </span>
            <img src="@/assets/images/arrow-down.png" class="d-none d-xl-block" style="width: 0.625rem; flex-shrink: 0;" />
          </div>
        </template>

        <a href="/" class="dropdown-item">
          <i class="bx bxs-dashboard font-size-16 align-middle mr-1"></i>
          {{ $t("dashboard.text") }}
        </a>
        <b-dropdown-divider></b-dropdown-divider>
        <a href="/account" class="dropdown-item">
          <i class="mdi mdi-account font-size-16 align-middle mr-1"></i>
          {{ $t("common.account-profile") }}
        </a>

        <a v-if="isAdminOrOwnerOfAnyWorkpace" href="/workspace" class="dropdown-item">
          <i class="mdi mdi-hexagon-multiple-outline font-size-16 align-middle mr-1"></i>
          {{ $t("workspace.my") }}
        </a>

        <b-dropdown-item @click="go('/management')" v-if="user.type == 'system'">
          <i class="bx bx-fingerprint font-size-16 align-middle mr-1"></i>
          {{ this.$t("pages.go-to-manager-app") }}
        </b-dropdown-item>

        <b-dropdown-item @click="goToPage('/forgot-password')">
          <i class="bx bx-lock font-size-16 align-middle mr-1"></i>
          {{ this.$t("account.change-password") }}
        </b-dropdown-item>
        <!-- item-->

        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="logOut()">
          <span class="text-danger">
            <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
            {{ $t("pages.logout") }}
          </span>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import FileManagerWidget from "@c/file-manager-widget";
import FileManagerProgressWidget from "@c/form/file-manager-progress-widget";
import NavbarNotification from "@c/navbar-notification";
import OrganizationSelector from "@cc/organization-selector";
import simplebar from "simplebar-vue";

export default {
  data() {
    return {};
  },
  components: {
    simplebar,
    FileManagerWidget,
    OrganizationSelector,
    NavbarNotification,
    FileManagerProgressWidget,
  },
  computed: {
    userLetterAvatar() {
      const arr = this.user.name?.split(" ");
      const avatar = [];
      for (const [i, value] of arr.entries()) {
        avatar.push(value.charAt(0));
        if (i == 1) {
          break;
        }
      }
      return avatar.join("");
    },
    user() {
      // TKP-236 n.13: oturum düşerken / yüklenmeden hesap boş — `user.avatar` / `user.type` çizimi çökertiyordu
      return this.$store.getters["user/account"] || {};
    },
  },
  mounted() {},
  methods: {
    goToPage(page) {
      this.$router.push(page);
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },

    go(path) {
      window.location.href = path;
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    async logOut() {
      await this.$store.dispatch("user/logOut");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("./header.scss");

.custom-header-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.875rem;
  height: 2.875rem;
  border-radius: 0.625rem;
  border: 1px solid #d0d0d0;
  position: relative;
  transition: background-color, color, 0.3s;
  cursor: pointer;
  background-color: #f4f6f8;
}
</style>
